import React from "react";

export function UserBubleType1({children}: any) {
  return (
    <div className="inner !rounded-br-none">
      {children}
    </div>
  )
}


export function BotBubleType1({children}: any) {
  return (
    <div className="inner !rounded-bl-none">
      {children}
    </div>
  )
}
